export default "__VITE_ASSET__iChdlPZG__"